import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import Google from './Google';
import Facebook from './Facebook';
import Tiktok from './Tiktok';
import Bing from './Bing';
import Pinterest from './Pinterest';
import Reddit from './Reddit';
import MediaInvestmentPerformance from './MediaInvestmentPerformance';
import OverallMedia from './OverallMedia';
import { useGetIfIsClientOnTikTokQuery, useGetIfIsClientOnBingQuery, useGetIfIsClientOnPinterestQuery, useGetIfIsClientOnRedditQuery } from '../../redux/api/genericReporting';
import { useSelector } from 'react-redux';

function PaidMediaPage() {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const [tabs, setTabs] = useState([
        {
            label: 'Overall Media Outlook',
            key: 'Overall Media Outlook',
            children: [<OverallMedia></OverallMedia>]
        },
        {
            label: 'Google',
            key: 'Google',
            children: [<Google></Google>]
        },
        {
            label: 'Facebook',
            key: 'Facebook',
            children: [<Facebook></Facebook>]
        }
    ]);

    const isClientOnTikTok = useGetIfIsClientOnTikTokQuery(
        {
            client: selectedClient
        }
    );

    const isClientOnBing = useGetIfIsClientOnBingQuery(
        {
            client: selectedClient
        }
    );

    const isClientOnPinterest = useGetIfIsClientOnPinterestQuery(
        {
            client: selectedClient
        }
    );

    const isClientOnReddit = useGetIfIsClientOnRedditQuery(
        {
            client: selectedClient
        }
    );

    useEffect(() => {

        var tmpTabs = [
            {
                label: 'Overall Media Outlook',
                key: 'Overall Media Outlook',
                children: [<OverallMedia></OverallMedia>]
            },
            {
                label: 'Google',
                key: 'Google',
                children: [<Google></Google>]
            },
            {
                label: 'Facebook',
                key: 'Facebook',
                children: [<Facebook></Facebook>]
            }
        ];

        if (isClientOnTikTok.data) {
            tmpTabs.push({
                label: 'Tiktok',
                key: 'Tiktok',
                children: [<Tiktok></Tiktok>]
            })
        }

        if (isClientOnBing.data) {
            tmpTabs.push({
                label: 'Bing',
                key: 'Bing',
                children: [<Bing></Bing>]
            })
        }

        if (isClientOnPinterest.data) {
            tmpTabs.push({
                label: 'Pinterest',
                key: 'Pinterest',
                children: [<Pinterest></Pinterest>]
            })
        }

        if (isClientOnReddit.data) {
            tmpTabs.push({
                label: 'Reddit',
                key: 'Reddit',
                children: [<Reddit></Reddit>]
            })
        }


        tmpTabs.push(
            {
                label: 'Media Investment Performance',
                key: 'Media Investment Performance',
                children: [<MediaInvestmentPerformance></MediaInvestmentPerformance>]
            }
        )

        setTabs(tmpTabs);
    }
        , [isClientOnTikTok, selectedClient, isClientOnBing, isClientOnPinterest, isClientOnReddit]);

    return (
        // JSX code for your component's UI goes here
        <div className='main-content-container'>
            <GenericReportingDropdowns></GenericReportingDropdowns>
            <Tabs items={tabs} ></Tabs>
        </div>
    );
}

export default PaidMediaPage;